import { DatePipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { LetregisterService } from '../letregister.service';
import { Letsikring } from '../letsikring.model';

@Component({
  selector: 'app-letregister-aftaler',
  imports: [TableRowDirective, TableModule, CprNummerPipe, DatePipe],
  templateUrl: './letregister-aftaler.component.html',
  styleUrl: './letregister-aftaler.component.css',
})
export class LetregisterResultComponent {
  letregisterService = inject(LetregisterService);
  selectionAktive = signal<Letsikring | undefined>(undefined);
  selectionUdgaaede = signal<Letsikring | undefined>(undefined);

  aktiveAftaler = computed(() => {
    const apiResponse = this.letregisterService.letsikringDatasource.data();
    return apiResponse.data.filter(
      x =>
        x.kundeId === this.letregisterService.selectedKunde()?.id &&
        !x.udgaaetDato
    );
  });

  udgaaedeAftaler = computed(() => {
    const apiResponse = this.letregisterService.letsikringDatasource.data();
    return apiResponse.data.filter(
      x =>
        x.kundeId === this.letregisterService.selectedKunde()?.id &&
        !!x.udgaaetDato
    );
  });

  onRowSelectAktive(e: TableRowSelectEvent) {
    if (this.selectionUdgaaede()) {
      this.selectionUdgaaede.set(undefined);
    }
    this.letregisterService.selectLetsikringResultRow(e.data);
  }

  onRowSelectUdgaaet(e: TableRowSelectEvent) {
    if (this.selectionAktive()) {
      this.selectionAktive.set(undefined);
    }

    this.letregisterService.selectLetsikringResultRow(e.data);
  }

  getTilknyttede(letsikring: Letsikring) {
    const tilknyttede =
      letsikring.gaeldendeRevision.tilknyttedeLetsikringRisiko || [];
    if (tilknyttede.length > 0) {
      return tilknyttede.map(x => x.produktNavn).join('<br/>');
    }
    return '';
  }
}
